var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
import { Stream, never, defaultScheduler as scheduler } from 'most';
import { MulticastSource } from '@most/multicast';
export function sync() {
    return asSync(never());
}
export function asSync(stream) {
    return new SyncSubject(new MulticastSource(stream.source));
}
var SyncSubject = (function (_super) {
    __extends(SyncSubject, _super);
    function SyncSubject(source) {
        return _super.call(this, source) || this;
    }
    SyncSubject.prototype.next = function (value) {
        this.source.event(scheduler.now(), value);
        return this;
    };
    SyncSubject.prototype.error = function (err) {
        this.source.error(scheduler.now(), err);
        return this;
    };
    SyncSubject.prototype.complete = function (value) {
        this.source.end(scheduler.now(), value);
        return this;
    };
    return SyncSubject;
}(Stream));
export { SyncSubject };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/most-subject/lib/es2015/subjects/sync/index.js
// module id = 861
// module chunks = 0